import t, { useContext as e } from "react";

var o = t.createContext({
  name: "default"
}),
    r = function r() {
  return e(o);
};

export { o as RadioGroupContext, r as useRadioGroupContext };